import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { referralAnalysesActions } from 'features/referralAnalyses';

const useReferralAnalyses = () => {
  const dispatch = useDispatch();
  const getReferralAnalyses = useCallback(({ offset }) => dispatch(referralAnalysesActions.getReferralAnalyses({ offset })), [dispatch]);
  const getReferralAnalysis = useCallback(({ id, cable }) => dispatch(referralAnalysesActions.getReferralAnalysis({ id, cable })), [dispatch]);
  const clearLocalReferralAnalyses = useCallback(() => dispatch(referralAnalysesActions.clearLocalReferralAnalyses()), [dispatch]);
  const clearLocalActiveReferralAnalysis = useCallback(() => dispatch(referralAnalysesActions.clearLocalActiveReferralAnalysis()), [dispatch]);

  return {
    getReferralAnalyses,
    getReferralAnalysis,
    clearLocalReferralAnalyses,
    clearLocalActiveReferralAnalysis
  };
};

export default useReferralAnalyses;